<mat-form-field appearance="outline" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" matTooltipPosition="above"
  matTooltipClass="sl-tooltip">

  <mat-label>
    {{label}} <app-required *ngIf="isRequired()"></app-required>
  </mat-label>

  <textarea matInput [formControl]="control" [placeholder]="placeholder? placeholder: ''"
    [maxlength]="maxlength"></textarea>

  <ng-container *ngIf="control && control.invalid" ngProjectAs="mat-error">
    <mat-error *ngIf="control.hasError('required')">
      {{label}} is <strong>required</strong>.
    </mat-error>
  </ng-container>

  <ng-container *ngIf="hint" ngProjectAs="mat-hint">
    <mat-hint>{{hint}}</mat-hint>
  </ng-container>

</mat-form-field>
